import type { HelpFile } from '../../types/help'
import { ParameterFormTestIds } from '../../../testids/ParameterFormTestIds'

export const parameterFormHelp: HelpFile = {
  docPage: '/docs/reporting/report-definitions',
  texts: {
    [ParameterFormTestIds.parameterForm]: 'Formular zur Eingabe von Werten für die vom ausgewählten Bericht benötigten Parameter.',
  },
}
